import { VStack } from '@bpba/ui-components';
import styled from 'styled-components';
import { ComponentProps } from 'react';

type OutlineVStackProps = {
  outline?: string;
} & ComponentProps<typeof VStack>;

export const OutlineVStack = styled(VStack)<OutlineVStackProps>((props) => ({
  outline: props.outline,
}));
